import React, { useContext } from 'react';
import leaderSpellingImg from './cards/leader_spelling.png';
import leaderWordlyImg from './cards/leader_wordly.png';
import leaderMemoryImg from './cards/leader_memory.png';
import { dataContext } from '../../App';

export default function NewLeaderboard({ setShowNewLeaderboardModal }) {
  const { setActiveLeaderboardName } = useContext(dataContext);

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding:'16px' }}>
        <img src={leaderWordlyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_wordly_bangla')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={leaderMemoryImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_memory_h')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={leaderSpellingImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('leaderboard_spelling')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
      </div>
    </>
  );
};
